import { Component, OnInit, Input } from '@angular/core';
import { BodyCell, IBodyCell } from '../../holders/body-cell.component';

@Component({
   selector: 'exi-checkbox-cell',
   template: `
      <exi-checkbox [value]="value" [ctx]="cell.args"></exi-checkbox>
  `,
   styleUrls: ['./checkbox.component.scss']
})
export class CheckboxCellComponent<D extends object> implements IBodyCell<D> {
   @Input() public value: D;
   @Input() public cell: CheckboxCell<D>;
   
}


export class CheckboxCell<D extends object> extends BodyCell<D> {
   constructor(public args: {
      get: (row: D) => boolean;
      set: (row: D) => void;
      isDisabled?: (row: D) => boolean;
   }) {
      super(CheckboxCellComponent, value => args.get(value) ? 'Yes' : 'No');
      args.isDisabled = args.isDisabled || (() => false);
   }
}
